module.exports = __webpack_public_path__ + "img/bg1.8f36a7cf.png";